var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"inline-block",style:(_vm.heightStyle),attrs:{"src":(_vm.publicPath + "/" + _vm.whiteOrBlackLogo)}})}
var staticRenderFns = []

export { render, staticRenderFns }